import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {Dictionary} from "../../../../types/rendering";


export default class WindowLiveChatMutator 
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    
    
    //#region Public Interface
    
    constructor(settings: DefaultSettings) 
    {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    getMutator()
    {
        return (parameters: Dictionary): Dictionary =>
        {
            if (this.isLiveChatDisconnected()) { return parameters; }

            if (!parameters.attributes) { parameters.attributes = {}; }

            const { Base, sessionState } = this._settings.stateLocations.LiveChat;
            (parameters.attributes as Dictionary)['data-livechat'] = this._store?.getState()[Base][sessionState];

            return parameters;
        };
    }
    
    //#endregion
    
    
    
    //#region Helper Methods

    isLiveChatDisconnected(): boolean
    {
        const { Base, sessionState } = this._settings.stateLocations.LiveChat;
        const currentState = this._store?.getState()[Base][sessionState];

        return currentState === this._settings.livechat.sessionState.offline;
    }
    
    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/window-mutator.ts